import { openBlock as t, createElementBlock as o, createElementVNode as e } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ e("path", {
  fill: "#D80027",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), c = /* @__PURE__ */ e("path", {
  fill: "#FFDA44",
  d: "m10.946 12.172 1.726 5.312h5.586l-4.516 3.29 1.727 5.312-4.523-3.281-4.524 3.281 1.735-5.313-4.524-3.289H9.22l1.727-5.312Zm12.765 18.805-1.32-1.625-1.953.757 1.133-1.757-1.32-1.633 2.023.539 1.14-1.758.11 2.094 2.031.539-1.961.75.117 2.094Zm2.625-4.766.625-2L25.251 23l2.093-.031.617-2 .68 1.984 2.094-.023-1.68 1.25.672 1.984-1.711-1.21-1.68 1.257Zm3.539-11.531-.922 1.883 1.5 1.46-2.07-.296-.922 1.875-.36-2.063-2.077-.297 1.86-.976-.36-2.07 1.5 1.46 1.851-.976Zm-6.109-5.703-.156 2.086 1.945.789-2.04.5-.148 2.093-1.101-1.78-2.04.5 1.352-1.602-1.109-1.774 1.945.79 1.352-1.602Z"
}, null, -1), s = [
  n,
  c
];
function r(i, d) {
  return t(), o("svg", l, [...s]);
}
const m = { render: r };
export {
  m as default,
  r as render
};
